import { render } from "./fcmadd.vue?vue&type=template&id=68011302&scoped=true"
import script from "./fcmadd.vue?vue&type=script&lang=js"
export * from "./fcmadd.vue?vue&type=script&lang=js"

import "./fcmadd.vue?vue&type=style&index=0&id=68011302&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68011302"]])

export default __exports__